import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import ReactPlayer from 'react-player';
import BackButton from '../../components/BackButton';
import { config } from '../../config/config';
import './Generatepage.css';
import shareicon from '../../assets/share_video.svg';
import deleteicon from '../../assets/delete_video.svg';
import downloadicon from '../../assets/download_video.svg';
import LeftPanel from '../../components/LeftPanel';
import NotificationBar from '../../components/NotificationBar';
import { analytics } from '../../firebase/firebase'; 
import { logEvent } from 'firebase/analytics'; 

const Generatepage = () => {
  const [videoUrl, setVideoUrl] = useState('');
  const [recordId, setRecordId] = useState(null);
  const [deleteResult, setDeleteResult] = useState('');
  const [deletingVideoId, setDeletingVideoId] = useState(null);
  const [showDeletePopup, setShowDeletePopup] = useState(false);

  const [isHistoryView, setIsHistoryView] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

React.useEffect(() => {
  document.documentElement.style.setProperty("--backbutton-color", 'White');  
}, []);
//Notification
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationType, setNotificationType] = useState("error");

  const triggerNotification = (message) => {
    setNotificationMessage(message);
    setShowNotification(true);
  };
const [searchParams] = useSearchParams();
const isEdited = searchParams.get("edited") === "1";




useEffect(() => {
    const params = new URLSearchParams(location.search);
    const rawVideoUrl = params.get('videoUrl');
    const rawRecordId = params.get('recordId');
    const historyFlag = params.get('history') === 'true';
    if (!rawVideoUrl || !rawRecordId) {
      navigate('/', { replace: true });
      return;
    }
    setVideoUrl(decodeURIComponent(rawVideoUrl));
    setRecordId(decodeURIComponent(rawRecordId));
    setIsHistoryView(historyFlag);
    window.history.replaceState({}, document.title, location.pathname);
    sessionStorage.setItem("hasFetchedHistory", "false");
  }, [location.search, location.pathname, navigate]);

  const backPath = isHistoryView
    ? '/Dashboard'
    : '/Dashboard';

  const pageTitle = isHistoryView
    ? 'Your video'
    : 'Text to video';



  const handleDelete = () => {
    setDeletingVideoId(videoUrl);
    setShowDeletePopup(true);
    logEvent(analytics, 'delete_video_clicked_FacelessVideo', {
      videoUrl,
      recordId,
    });
  };

  const confirmDelete = async () => {
    try {
      const res = await fetch(`${config.baseURL}/delete_video.php`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          videoId: deletingVideoId,
          recordId: recordId
        }),
      });
      const result = await res.json();

      if (result.success) {
        setDeleteResult('success');
         logEvent(analytics, 'delete_video_success_FacelessVideo', {
          videoUrl: deletingVideoId,
          recordId,
        });
        setTimeout(() => {
          setShowDeletePopup(false);
           logEvent(analytics, 'delete_video_failure_FacelessVideo', {
          videoUrl: deletingVideoId,
          recordId,
          error_message: result.message || 'Unknown error',
        });
          setDeleteResult('');
          navigate('/'); // go back after deletion
        }, 1000);
      } else {
        setDeleteResult('failure');
      }
    } catch (err) {
      setDeleteResult('failure');
       logEvent(analytics, 'delete_video_failure_FacelessVideo', {
        videoUrl: deletingVideoId,
        recordId,
        error_message: err.message || 'Network error',
        error_stack: err.stack || 'No stack trace',
      });
    }
  };

  const cancelDelete = () => {
    setShowDeletePopup(false);
    setDeleteResult('');
  };

  const handleShare = async () => {
    try {
      const shareData = {
        title: 'Check out my AI-generated video!',
        text: 'I just made this with Ai Video Generator. Give it a try!',
        url: videoUrl,
      };
       logEvent(analytics, 'share_video_clicked_FacelessVideo', {
        videoUrl,
        recordId,
      });
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        alert('Sharing not supported on this browser.');
      }
    } catch {
      alert('Sharing failed. Please try again.');
    }
  };

  const handleDownload = async () => {
    try {
        logEvent(analytics, 'download_video_clicked_FacelessVideo', {
        videoUrl,
        recordId,
      });
      const res = await fetch(videoUrl, { method: 'GET', headers: { 'Accept': 'video/mp4' } });
      if (!res.ok) throw new Error();
      const blob = await res.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = 'AiVideoGenerator.mp4';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(blobUrl);
      document.body.removeChild(a);
    } catch {
      console.error('Download failed');
    }
  };



  const handleEdit = () => {
  // Log event for analytics
  logEvent(analytics, 'edit_video_clicked_FacelessVideo', {
    recordId,
    videoUrl,
  });

  // Navigate to edit page and pass recordId + videoUrl as query params
  navigate(`/edit?recordId=${encodeURIComponent(recordId)}&videoUrl=${encodeURIComponent(videoUrl)}`);
};


  return (
    <div className='Generatepage'>
    <LeftPanel/>

    <div className="generate-page-container">
      <div className="generate-topdiv">
        <BackButton  onClick={() => navigate(backPath)} title={pageTitle} />
          
          <div className='title_generatepage'>{pageTitle}</div>

            <div className="button_generatepage_pc">
        <button className="action-button_generatepage" onClick={handleDelete}>
          <img src={deleteicon} alt="Delete" className="btn_img_generatepage" />
        </button>
        <button
          className="action-button_generatepage"
          onClick={handleShare}
        >
          <img src={shareicon} alt="Share" className="btn_img_generatepage" />
        </button>
        <button
          className="action-button_generatepage"
          onClick={handleDownload}
        >
          <img src={downloadicon} alt="Download" className="btn_img_generatepage" />
        </button>
         {!isEdited && (
  <button
    className="action-button_generatepage"
     onClick={handleEdit}
  >
    Edit
  </button>
)}
      </div>
      </div>

      <div 
      className="video-container_generatepage" 
>
        {videoUrl && (
          <ReactPlayer
            url={videoUrl}
            controls
            width="100%"
            height="100%"
            style={{
              borderRadius: '20px',
              overflow: 'hidden',
              backgroundColor:'#22222A'

            }}
            
          />
        )}
      </div>

      {showDeletePopup && (
        <div className="delete-popup_generatepage">
          <div className="delete-popup_generatepage_white">
            <p>Are you sure you want to delete this video?</p>
            <button onClick={confirmDelete}>Yes, Delete</button>
            <button onClick={cancelDelete}>Cancel</button>
            {deleteResult && (
              <div className={`delete-result ${deleteResult}`}>
                {deleteResult === 'success'
                  ? 'Video deleted successfully.'
                  : 'Failed to delete video.'}
              </div>
            )}
          </div>
        </div>
      )}

      <div className="button-container_generatepage">
        <button className="action-button_generatepage" onClick={handleDelete}>
          <img src={deleteicon} alt="Delete" className="btn_img_generatepage" />
        </button>
        <button
          className="action-button_generatepage"
          onClick={handleShare}
        >
          <img src={shareicon} alt="Share" className="btn_img_generatepage" />
        </button>
        <button
          className="action-button_generatepage"
          onClick={handleDownload}
        >
          <img src={downloadicon} alt="Download" className="btn_img_generatepage" />
        </button>
        {!isEdited && (
  <button
    className="action-button_generatepage"
     onClick={handleEdit}
  >
    Edit
  </button>
)}

      </div>
    </div>
    <NotificationBar
          visible={showNotification}
          message={notificationMessage}
          onClose={() => setShowNotification(false)}
        />
    </div>
  );
};

export default Generatepage;
